"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "tregnago": {
    "68d89e15": [{
      "hkey": "f137eed3",
      "slug": "frazione-centro-masetto",
      "name": "Frazione Centro-Masetto",
      "primary": true,
      "skipSearch": false
    }],
    "centro-masetto": [{
      "hkey": "f137eed3",
      "slug": "frazione-centro-masetto",
      "name": "Frazione Centro-Masetto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "ff81415a": [{
      "hkey": "f137eed3",
      "slug": "frazione-centro-masetto",
      "name": "Frazione Centro-Masetto",
      "primary": true,
      "skipSearch": false
    }],
    "centro": [{
      "hkey": "f137eed3",
      "slug": "frazione-centro-masetto",
      "name": "Frazione Centro-Masetto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;